export const AnimatedYeatiText = ({ replaceLogo = false }: { replaceLogo?: boolean }) => {
  return <span className={`animated-yeati-text ml-1 ${replaceLogo && "text-3xl"}`}>YEATI</span>;
};
